import React from 'react';
import { StepButtons } from '../components/StepButtons';
import { withLayout } from 'helpers';
import { YoureNotAloneDecoration } from '../components/QuestionDecoration';

function YoureNotAlone({ onBack, onNext }) {
  return (
    <div className="misc1-container">
      <div className="content">
        <div className="header">
          <StepButtons onBack={onBack} onNext={onNext} />
        </div>

        <div className="title_container banner_container">
          <h1 className="label statement_title">
            Thanks for sharing. You’re not alone.
          </h1>

          <h2 className="label statement_subtitle">
            An estimated 26% of Americans aged 18 and older (approx. 1 in 4
            adults) suffers from a diagnosable mental disorder in a given year.
            <br />
            Many people suffer from more than one mental disorder at a given
            time.
            <br />
            <br />
            Multiple clinical trials have shown ketamine's profound ability to
            treat depression, anxiety, and PTSD. It's shorter-acting dictable
            than other psychedelics. Let's keep going.
          </h2>
        </div>
      </div>

      <YoureNotAloneDecoration />
    </div>
  );
}

YoureNotAlone.title = 'Thanks for Sharing | Nue Life Questionnaire';

export const YoureNotAloneScreen = withLayout(YoureNotAlone);